
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.266 15.666c0 .44-.356.796-.796.796h-2.94a.796.796 0 010-1.592h2.94c.44 0 .796.356.796.796zM24 3.756v4.946c0 .44-.357.796-.796.796h-.516v10.744c0 .44-.357.796-.797.796H2.11a.796.796 0 01-.796-.796V9.498H.796A.796.796 0 010 8.702V3.756c0-.44.357-.796.796-.796h22.408c.44 0 .796.356.796.796zm-2.905 5.742h-5.08A4.1 4.1 0 0112 12.795a4.1 4.1 0 01-4.016-3.297H2.905v9.947h18.19V9.498zM12 11.203c1.1 0 2.038-.715 2.37-1.705H9.63A2.505 2.505 0 0012 11.203zm10.407-6.65H1.593v3.353h20.814V4.553z","fill":"#000"}})])
          )
        }
      }
    